var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ControlOption',{attrs:{"campos":_vm.campos,"camposIndex":_vm.camposIndex}},[_c('v-text-field',{attrs:{"label":_vm.campos.pregunta + (_vm.campos.obligatorio== 1 ? '  **' : ''),"placeholder":"  ","disabled":""}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }